const navItems = [
    {
        pagePath: '/',
        label: 'Home',
        icon: '/icon/home.webp',
        isUpdated: true,
        lastUpdated: '2025-09-15'
    },
    {
        pagePath: '/pages/reels',
        label: '릴 정보',
        icon: '/icon/reels.webp',
        isUpdated: true,
        lastUpdated: '2025-09-15'
    },
    {
        pagePath: '/pages/rod',
        label: '낚싯대 정보',
        icon: '/icon/rod.webp',
        isUpdated: true,
        lastUpdated: '2025-09-15'
    },
    {
        pagePath: '/pages/line',
        label: '낚싯줄 정보',
        icon: '/icon/line.webp',
        isUpdated: true,
        lastUpdated: '2025-09-15'
    },
    {
        pagePath: '/pages/hooks',
        label: '바늘 하중 정보',
        icon: '/icon/hooks.webp',
        isUpdated: true,
        lastUpdated: '2025-09-15'
    },
    {
        pagePath: '/pages/interactive_maps',
        label: '반응형 지도',
        icon: '/icon/ext/papermap_komar_01.webp',
        isUpdated: true,
        lastUpdated: '2025-11-23'
    },
    {
        pagePath: '/pages/records',
        label: '기록실',
        icon: '/icon/records.webp',
        isUpdated: true,
        lastUpdated: '2025-11-07'
    },
    {
        pagePath: '/pages/cafeorder',
        label: '카페 오더',
        icon: '/icon/cafeorder.webp',
        isUpdated: true,
        lastUpdated: '2025-09-15'
    },
    {
        pagePath: '/pages/oil',
        label: '릴 오일 정보',
        icon: '/icon/oil.webp',
        isUpdated: true,
        lastUpdated: '2025-09-15'
    },
    {
        pagePath: '/pages/drink',
        label: '술 정보',
        icon: '/icon/drink.webp',
        isUpdated: true,
        lastUpdated: '2025-09-15'
    },
    {
        pagePath: '/pages/fishes',
        label: '어종 번역',
        icon: '/icon/fish_translate.webp',
        isUpdated: true,
        lastUpdated: '2025-11-01'
    },
    {
        pagePath: '/pages/groundbaits',
        label: '미끼 밑밥 번역',
        icon: '/icon/bait.webp',
        isUpdated: true,
        lastUpdated: '2025-10-19'
    },
    {
        pagePath: '/pages/baitcalculator',
        label: '미끼 밑밥 계산기',
        icon: '/icon/baitcalculator.webp',
        isUpdated: true,
        lastUpdated: '2025-12-03'
    },
    {
        pagePath: '/pages/trophy',
        label: '트로피 사이즈',
        icon: '/icon/trophy.webp',
        isUpdated: true,
        lastUpdated: '2025-10-19'
    },
    {
        pagePath: '/pages/duration',
        label: '채비 계산기',
        icon: '/icon/duration.webp',
        isUpdated: true,
        lastUpdated: '2025-12-09'
    },
    {
        pagePath: '/pages/ordertimer',
        label: '오더 & 어망 타이머',
        icon: '/icon/bell.webp',
        isUpdated: true,
        lastUpdated: '2025-09-15'
    },
    {
        pagePath: '/pages/food',
        label: '수제음식 레시피',
        icon: '/icon/food.webp',
        isUpdated: true,
        lastUpdated: '2025-09-15'
    },
    {
        pagePath: '/pages/lure',
        label: '수제루어 레시피',
        icon: '/icon/lure.webp',
        isUpdated: true,
        lastUpdated: '2025-09-15'
    },
    {
        pagePath: '/pages/price',
        label: '수역별 시세',
        icon: '/icon/price.webp',
        isUpdated: true,
        lastUpdated: '2025-09-15'
    },
    {
        pagePath: '/pages/tacklexp',
        label: '채비별 경험치 배율',
        icon: '/icon/tacklexp.webp',
        isUpdated: true,
        lastUpdated: '2025-09-15'
    },
    {
        pagePath: '/pages/xptable',
        label: 'XP',
        icon: '/icon/xptable.webp',
        isUpdated: true,
        lastUpdated: '2025-09-15'
    },
    {
        pagePath: '/pages/skill',
        label: '스킬 정리',
        icon: '/icon/skill.webp',
        isUpdated: true,
        lastUpdated: '2025-09-15'
    },
    {
        pagePath: '/pages/qualification',
        label: '자격 정리',
        icon: '/icon/qualification.webp',
        isUpdated: true,
        lastUpdated: '2025-09-15'
    },
    {
        pagePath: '/pages/updatelog',
        label: '업데이트 기록',
        icon: '/icon/updatelog.webp',
        isUpdated: true,
        lastUpdated: '2025-09-15'
    },
];

export {navItems};